import Button from '../../shared/UI/Button';

export default function RubricPreview({ rubric, onClose }) {
  if (!rubric) return null;
  const questions = rubric.questions || [];

  return (
    <div>
      <div className="mb-4" style={{ padding: '14px 16px', background: 'var(--color-border-light)', borderRadius: 'var(--radius)', border: '1px solid var(--color-border)' }}>
        <strong>{rubric.name}</strong>
        <p className="text-muted" style={{ fontSize: 13, marginTop: 4 }}>
          Normalisation factor: <strong>{rubric.normalisation_factor}</strong> &nbsp;·&nbsp;
          Advancement threshold: <strong>{rubric.advancement_threshold}</strong> &nbsp;·&nbsp;
          {questions.length} question{questions.length !== 1 ? 's' : ''}
        </p>
      </div>
      <div className="alert alert-info mb-4" style={{ fontSize: 13 }}>
        Read-only preview — this is how the rubric will appear in the PIF form.
      </div>

      {questions.length === 0 && (
        <div className="empty-state">
          <div className="empty-state-icon">📋</div>
          <h3>No questions yet</h3>
          <p>Add questions in the Question Builder to see a preview.</p>
        </div>
      )}

      {questions.map((q, idx) => (
        <div key={q.question_id} className="rubric-preview-question">
          <h4 style={{ marginBottom: 8 }}>
            {idx + 1}.&nbsp;
            {q.question_text || <em style={{ color: 'var(--color-text-secondary)', fontWeight: 400 }}>No question text</em>}
            {q.is_required && <span className="required" style={{ marginLeft: 4 }}>*</span>}
          </h4>
          <p className="text-muted" style={{ fontSize: 12, marginBottom: 10 }}>
            Type: {q.response_type?.replace('_', ' ')} · Weight: {q.weight}
            {q.allow_document_upload ? ' · Document upload enabled' : ''}
          </p>

          {(q.response_type === 'binary' || q.response_type === 'multiple_choice') &&
            (q.options || []).map(opt => (
              <div key={opt.option_id} className="rubric-preview-option">
                <input type="radio" disabled readOnly />
                <span>
                  {opt.option_text || <em className="text-muted">No text</em>}
                  <span className="text-muted" style={{ fontSize: 11, marginLeft: 8 }}>(score: {opt.score})</span>
                </span>
              </div>
            ))
          }

          {q.response_type === 'figure' && (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <input type="number" className="form-input" disabled placeholder="Enter value" style={{ maxWidth: 180 }} />
                {q.figure_unit && <span className="text-muted">{q.figure_unit}</span>}
              </div>
              {(q.figure_score_bands || []).length > 0 && (
                <p className="text-muted" style={{ fontSize: 12 }}>
                  Score bands: {q.figure_score_bands.map(b => `${b.min}–${b.max} → ${b.score}`).join(', ')}
                </p>
              )}
            </div>
          )}

          {q.allow_document_upload && (
            <div className="mt-2" style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
              📎 Document upload available for this question
            </div>
          )}
        </div>
      ))}

      {onClose && (
        <div className="mt-4">
          <Button variant="secondary" onClick={onClose}>Close Preview</Button>
        </div>
      )}
    </div>
  );
}
